import { formatCurrency } from '@angular/common';
import {DetailScreen} from '../mapping-classes/detail-screen';
import {DetailPanel} from '../mapping-classes/detail-panel';
import {DetailLabel} from '../mapping-classes/detail-label';
import {ButtonData} from "../mapping-classes/button-data";

export class Sparen implements DetailScreen {
  buttons;
  restrictedData: boolean;
  title: string;
  actualityDateTime: string;
  panels: DetailPanel[];
  nameValues: DetailLabel[];
  shieldedText = 'Afgeschermd';
  errorText: string;

  constructor(response: any) {
    this.title = 'Sparen (Productnaam Sparen)';
    this.buttons = [];
    this.restrictedData = false;
    if (response.detailsViewObject) {
      this.title = response.detailsViewObject.productName || this.title;
    }

    if (response.listOfError && response.listOfError.length) {
      this.createErrorMessage(response);
    } else {
      this.panels = [];
      this.nameValues = [];
      this.setPanels();
      this.setNameAndValues(response);
      this.addValues(response);
      this.addButtons(response.detailsViewObject);
    }
  }

  addButtons(res) {
    const data =  {
      arrangementNumber: res.iban.substring(8),
      administrationCode: res.adminCode,
    };
    this.buttons.push(new ButtonData(
      'cockpiturl',
      null,
      null,
      null,
      'B&O Cockpit',
      null,
      'boc-url', data));
    this.buttons.push(new ButtonData(
      'geldOverPortaalurl',
      null,
      null,
      null,
      'Medewerkers App Geld Over',
      null,
      'geldOver-url', res.relationId));
  }

  setPanels() {
    this.panels.push(new DetailPanel('Productkenmerken'));
    this.panels.push(new DetailPanel('Productafspraken'));
    this.panels.push(new DetailPanel('Productgebruik'));
  }

  setNameAndValues(response?) {
    const productDetailsPanel: DetailPanel = this.panels[0];
    const productAgreements:  DetailPanel = this.panels[1];
    const productUse:  DetailPanel = this.panels[2];

    this.fillProductDetailsPanel(productDetailsPanel);
    this.fillProductAgreementsPanel(productAgreements);
    this.fillProductUsePanel(productUse);
  }

  addValues(response: any) {
    const obj = response.detailsViewObject;
    const productDetailsPanel: DetailPanel = this.panels[0];
    const productAgreementsPanel: DetailPanel = this.panels[1];
    const productUsePanel: DetailPanel = this.panels[2];
    this.addValuesToProductDetailsPanel(productDetailsPanel, obj);
    this.addValuesToProductAgreementsPanel(productAgreementsPanel, obj);
    this.addValuesToProductUsePanel(productUsePanel, obj);
  }

  createErrorMessage(response) {
    if (response.listOfError && response.listOfError.length !== 0) {
      if (response.listOfError[0].code === 'CIV_F025') {
        this.errorText = 'Geen detail gegevens gevonden.';
      } else if (response.listOfError[0].code) {
        this.errorText = 'Product niet gevonden.';
      }
    }
  }

  private fillProductDetailsPanel(productDetailsPanel: DetailPanel) {
    productDetailsPanel.nameAndValues.set('iban', new DetailLabel('Rekeningnummer'));
    productDetailsPanel.nameAndValues.set('accountStatus', new DetailLabel('Status'));
    productDetailsPanel.nameAndValues.set('code', new DetailLabel('ABB Code (Overig)'));
    productDetailsPanel.nameAndValues.set('description', new DetailLabel('Omschrijving'));
    productDetailsPanel.nameAndValues.set('ascriptionId', new DetailLabel('Tenaamstelling'));
  }

  private addValuesToProductDetailsPanel(productDetailsPanel: DetailPanel, obj) {
    productDetailsPanel.nameAndValues.get('iban').setValue(obj.iban || '-');
    productDetailsPanel.nameAndValues.get('accountStatus').setValue(obj.accountStatus || '-');
    productDetailsPanel.nameAndValues.get('code').setValue((obj.abbCode) ? obj.abbCode.code : '-');
    productDetailsPanel.nameAndValues.get('description').setValue((obj.abbCode) ? obj.abbCode.description : '-');
    productDetailsPanel.nameAndValues.get('ascriptionId').setValue(obj.tenaamstelling || '-');
  }

  private fillProductAgreementsPanel(productDetailsPanel: DetailPanel) {
    productDetailsPanel.nameAndValues.set('releaseAmountAccountIban', new DetailLabel('Vrijboekrekening'));
    productDetailsPanel.nameAndValues.set('interestAccountAscriptionName', new DetailLabel('Tenaamstelling'));
    productDetailsPanel.nameAndValues.set('interestAccountIban', new DetailLabel('Renterekening'));
    productDetailsPanel.nameAndValues.set('releaseAmountAccountAscriptionName', new DetailLabel('Tenaamstelling'));
    productDetailsPanel.nameAndValues.set('agreementAbbCodeCode', new DetailLabel('Overeenkomst ABB Code'));
    productDetailsPanel.nameAndValues.set('startDate', new DetailLabel('Ingangsdatum'));
    productDetailsPanel.nameAndValues.set('endDate', new DetailLabel('Einddatum'));
    productDetailsPanel.nameAndValues.set('lastMutationDate', new DetailLabel('Laatste mutatie'));
    productDetailsPanel.nameAndValues.set('adviceOnDiscontinue', new DetailLabel('Advies bij afsluiten'));
    productDetailsPanel.nameAndValues.set('agreementAbbCodeDescription', new DetailLabel('Omschrijving'));
  }

  private addValuesToProductAgreementsPanel(productDetailsPanel: DetailPanel, obj) {
    productDetailsPanel.nameAndValues.get('releaseAmountAccountIban').setValue((obj.releaseAmountAccount)
      ? obj.releaseAmountAccount.iban  : '-');
    productDetailsPanel.nameAndValues.get('releaseAmountAccountAscriptionName').setValue((obj.releaseAmountAccount)
      ? obj.releaseAmountAccount.ascriptionName : '-');
    productDetailsPanel.nameAndValues.get('interestAccountIban').setValue((obj.interestAccount)
      ? obj.interestAccount.iban : '-');
    productDetailsPanel.nameAndValues.get('interestAccountAscriptionName').setValue((obj.interestAccount)
      ? obj.interestAccount.ascriptionName : '-');
    productDetailsPanel.nameAndValues.get('agreementAbbCodeCode').setValue((obj.agreementAbbCode)
      ? obj.agreementAbbCode.code : '-');
    productDetailsPanel.nameAndValues.get('startDate').setValue(obj.startDate || '-');
    productDetailsPanel.nameAndValues.get('endDate').setValue(obj.endDate || '-');
    productDetailsPanel.nameAndValues.get('lastMutationDate').setValue(obj.lastMutationDate || '-');
    productDetailsPanel.nameAndValues.get('adviceOnDiscontinue').setValue(obj.adviceOnDiscontinue || '-');
    productDetailsPanel.nameAndValues.get('agreementAbbCodeDescription').setValue((obj.agreementAbbCode)
      ? obj.agreementAbbCode.description : '-');
  }

  private fillProductUsePanel(productDetailsPanel: DetailPanel) {
    productDetailsPanel.nameAndValues.set('balance', new DetailLabel('Saldo Actueel'));
    productDetailsPanel.nameAndValues.set('accruedInterest', new DetailLabel('Opgebouwde rente'));
  }

  private addValuesToProductUsePanel(productDetailsPanel: DetailPanel, obj) {
    productDetailsPanel.nameAndValues.get('balance').setValue(formatCurrency(obj.balance, 'nl', '€') || '-');
    productDetailsPanel.nameAndValues.get('accruedInterest').setValue(formatCurrency(obj.accruedInterest, 'nl', '€') || '-');
  }
}
